import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoInclude, DtoRef, DtoRefList } from "../../../core/store/dto/dto";

export class MembershipDto extends AccountObjectDto {
    @DtoRef
    user: string;
    @DtoRefList
    accessGroups: Array<string>;
    @DtoRefList
    contactTypes: Array<string>;
    @DtoRefList
    lookupTypes: Array<string>;
    @DtoRefList
    jobTypes: Array<string>;
    @DtoRefList
    jobStatuses: Array<string>;
    @DtoRefList
    taskTypes: Array<string>;
    @DtoInclude
    admin: boolean;

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.dto.ts